const encodeFilterData = (data) => {
  return encodeURIComponent(JSON.stringify(data));
};

const decodeFilterData = (filterData) => {
  let parsedFilters = [];
  if (filterData) {
    parsedFilters = JSON.parse(decodeURIComponent(filterData));
  }

  return parsedFilters;
};

export { encodeFilterData, decodeFilterData };
